import { getTranslatedString } from 'helpers/i18n';
import { parsePhoneNumberFromString, isPossibleNumber } from 'libphonenumber-js';

const defaultCountryCode = 'CA';

export const convertPhoneNumberStringToObject = (phoneNumber) => {
  if (phoneNumber === null) {
    return {};
  }

  if (typeof phoneNumber === 'object') {
    return phoneNumber;
  }

  if (!phoneNumber) {
    return {};
  }

  const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber, defaultCountryCode);

  // If phone number is invalid, return an empty object
  if (!parsedPhoneNumber) {
    return {};
  }

  return {
    phone: parsedPhoneNumber.nationalNumber,
    code: parsedPhoneNumber.countryCallingCode,
    short: parsedPhoneNumber.country || defaultCountryCode,
  };
};

export const convertPhoneNumberObjectToString = (phoneObject) => {
  if (!phoneObject) return;
  if (typeof phoneObject === 'string') return phoneObject;

  return parsePhoneNumberFromString(
    `+${phoneObject.code}${phoneObject.phone}`
  ).formatInternational();
};

export const inputPhoneAntdFormValidator = (_, value) => {
  if (!value) {
    return Promise.reject(getTranslatedString('validationErrors.invalidPhone'));
  }

  let phone;
  let short;

  if (typeof value === 'string') {
    phone = value;
  } else {
    phone = value.phone;
    short = value.short;
  }

  if (!phone) {
    return Promise.reject(getTranslatedString('validationErrors.invalidPhone'));
  }

  if (isPossibleNumber(phone, short)) {
    return Promise.resolve();
  }

  return Promise.reject(getTranslatedString('validationErrors.invalidPhone'));
};
